var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var initialState = {
    status: false,
    expandSubscriptions: false,
    areTracksExpanded: false,
    scrollPosition: 0,
    isViewOnlyMode: false,
};
var sidebarReducer = function (state, _a) {
    if (state === void 0) { state = initialState; }
    var type = _a.type, payload = _a.payload;
    switch (type) {
        case 'TOGGLE_SIDEBAR':
            return __assign(__assign({}, state), { status: payload.status });
        case 'TOGGLE_SUBSCRIPTION_MENU':
            return __assign(__assign({}, state), { expandSubscriptions: payload.status });
        case 'TOGGLE_TRACKS_EXPAND_MENU':
            return __assign(__assign({}, state), { areTracksExpanded: payload.status });
        case 'UPDATE_LAST_SCROLL_POSITION':
            return __assign(__assign({}, state), { scrollPosition: payload.status });
        case 'UPDATE_SIDEBAR_OPEN':
            return __assign(__assign({}, state), { isSideBarOpen: payload.status });
        case '[USER] LOGGED OUT':
            return __assign(__assign({}, state), { status: false });
        default:
            return state;
    }
};
export default sidebarReducer;



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/sidebar.reducer.ts
// module id = 1459
// module chunks = 81